import { useFieldArray, UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { FormValues } from '../../../UpsertTrustModal.meta';

type BeneficiaryFieldName = 'beneficiaries.primary' | 'beneficiaries.contingent';

interface UseBeneficiaryFieldArrayParams {
  fieldName: BeneficiaryFieldName;
}

export type BeneficiaryFieldArray = UseFieldArrayReturn<FormValues, BeneficiaryFieldName, 'key'>;

export const useBeneficiaryFieldArray = ({
  fieldName,
}: UseBeneficiaryFieldArrayParams): BeneficiaryFieldArray => {
  const formBag = useFormContext<FormValues>();

  const fieldArrayBag = useFieldArray({
    control: formBag.control,
    name: fieldName,
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch(fieldName);
  const controlledFields = fieldArrayBag.fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  return {
    ...fieldArrayBag,
    fields: controlledFields,
  };
};
